import { AnimatePresence } from 'framer-motion'
import { FC, useMemo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Button from '@app/components/Button/Button'
import ReactMarkdown from 'react-markdown'
import { unflatten } from 'flat'
import { UnflattenedLangProps } from '@app/lang/types'
import S from './SerialNumberHelper.styles'

interface SerialNumberHelperProps {
  show: boolean
  /** callback */
  onExit?: () => void
}

const SerialNumberHelper: FC<SerialNumberHelperProps> = ({ show, onExit }) => {
  const { messages } = useIntl()

  const exit = () => {
    onExit?.()
  }

  const options = useMemo(() => {
    const data = unflatten(messages) as UnflattenedLangProps
    return data?.quiz_purchased_product_page?.content?.serial_number_dialog?.items ?? []
  }, [messages])

  return (
    <AnimatePresence>
      {show && (
        <>
          <S.Backdrop initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={exit} />
          <S.Wrapper initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 0, opacity: 0 }}>
            <S.Content $length={options.length}>
              {options.map(option => (
                <div key={option.id}>
                  <ReactMarkdown>{option.content}</ReactMarkdown>
                  <img src={option.image} alt="" />
                </div>
              ))}
            </S.Content>
            <S.Actions>
              <Button onClick={exit}>
                <FormattedMessage id="quiz_purchased_product_page.content.serial_number_dialog.close_dialog" />
              </Button>
            </S.Actions>
          </S.Wrapper>
        </>
      )}
    </AnimatePresence>
  )
}

export default SerialNumberHelper
